module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-RegularItalic-bff3d17c8a6870bdf2f7e311d12f3eaf.ttf";